import {connect} from 'react-redux';
import BatchActionsScreen from '../../components/screens/BatchActionsScreen';

const BatchActionsScreenContainer = connect(
    null,
    null
)(BatchActionsScreen);

export default BatchActionsScreenContainer;